import { render, staticRenderFns } from "./SVGCard.vue?vue&type=template&id=12cf6a88&scoped=true&"
import script from "./SVGCard.vue?vue&type=script&lang=js&"
export * from "./SVGCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf6a88",
  null
  
)

export default component.exports